module.exports = __webpack_public_path__ + "static/media/joinleague.1e95d5d0.png";